import { FormGroup } from '@angular/forms';
import { AccountTypeBeneficiaryFormGroup } from '../forms/account-type-beneficiary-form-group';
import { BeneficiaryTypeEnum } from '../enums/beneficiary-type.enum';
import { AccountTypeIdEnum } from '../../../models/enum/shared/account-type-id.enum';

export class BeneficiarySpouseUtils {
  /**
   * The beneficiary type a member's spouse is assigned for a given account type. Variable Benefit
   * spouses are `Specified`; every other account type (including Defined Contribution) keeps `Spousal`.
   */
  public static spouseBeneficiaryTypeForAccountType(
    accountTypeId: AccountTypeIdEnum | null | undefined
  ): BeneficiaryTypeEnum {
    return accountTypeId === AccountTypeIdEnum.VariableBenefit
      ? BeneficiaryTypeEnum.Specified
      : BeneficiaryTypeEnum.Spousal;
  }

  public static formIsSpouse(form: FormGroup<AccountTypeBeneficiaryFormGroup>): boolean {
    return !!form.controls.linkedSpouseId.getRawValue();
  }

  public static isSpouseBeneficiaryType(typeId: BeneficiaryTypeEnum | null | undefined): boolean {
    return typeId === BeneficiaryTypeEnum.Spousal || typeId === BeneficiaryTypeEnum.Specified;
  }
}
